export const CSS_CLASS_CORE_BLOCKS = 'ee-core-blocks event-espresso-blocks';
